import { useParams, Navigate } from "react-router-dom";

/**
 * Shortlink resolver — accepts /s/<reference>-<plz>
 * Splits on the LAST dash so references containing dashes still work.
 */
export const ShortlinkRedirect = () => {
  const { slug } = useParams();
  if (!slug) return <Navigate to="/" replace />;

  const idx = slug.lastIndexOf("-");
  if (idx <= 0 || idx === slug.length - 1) {
    return <Navigate to="/" replace />;
  }
  const reference = slug.slice(0, idx);
  const plz = slug.slice(idx + 1);
  if (!reference.trim() || !plz.trim()) {
    return <Navigate to="/" replace />;
  }
  return (
    <Navigate
      to={`/track/${encodeURIComponent(reference)}?plz=${encodeURIComponent(plz)}`}
      replace
    />
  );
};
